export default __webpack_public_path__ + "static/media/wnew2.27ee9965.png";